var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeEvery } from "redux-saga/effects";
import { fetchQuickRatesFailure, fetchQuickRatesSuccess, FETCH_QUICK_RATES_REQUEST, } from "../../actions";
import APIIN from "@/utils/APIIN";
const fetchQuickRates = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            console.log("sending request");
            APIIN.post("/cnvt/rates/quick", action.payload)
                .then((response) => {
                console.log(response);
                resolve(response);
            })
                .catch((error) => {
                console.log(error);
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                console.log("reject: ", error);
                reject(error);
            }
        }
    }));
});
function* fetchQuickRatesDataWorker(action) {
    try {
        const data = yield call(fetchQuickRates, action);
        yield put(fetchQuickRatesSuccess(data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            // If error response contains a message, dispatch it
            yield put(fetchQuickRatesFailure(error.response.data.message));
        }
        else {
            // If not, dispatch a generic error message
            yield put(fetchQuickRatesFailure(error));
        }
    }
}
export function* watchFetchQuickRatesData() {
    yield takeEvery(FETCH_QUICK_RATES_REQUEST, fetchQuickRatesDataWorker);
}
